/* eslint-disable indent */
import { ToastInterface, TYPE, useToast } from "vue-toastification";
import { IToastNotification } from "./types";
import { injectable } from "inversify";
import "reflect-metadata";
import MaterialIcon from "@/components/MaterialIcon.vue";
import { h } from "vue";

@injectable()
export default class VueNotificationAdapter
  implements IToastNotification<unknown>
{
  private toast: ToastInterface;

  constructor() {
    this.toast = useToast();
  }

  showHtmlNotification(
    message: string,
    options?: Record<string, unknown>
  ): unknown {
    const HtmlToastContent = {
      props: ["content"],
      render() {
        return h("div", {
          innerHTML: message,
          style: { textAlign: "justify" }
        });
      }
    };

    return this.toast(
      { component: HtmlToastContent, props: { content: message } },
      options
    );
  }

  showNotification = (message: string, options?: Record<string, unknown>) => {
    const toastClass = this.notificationClass(options?.type as TYPE);

    const toastId = this.toast(message, {
      toastClassName: toastClass.toast,
      closeButton: () => {
        return h(
          "div",
          {
            class: toastClass.close,
            onclick: () => this.toast.dismiss(toastId)
          },
          [h(MaterialIcon, { icon: "close" })]
        );
      },
      ...options
    });

    return toastId;
  };

  updateNotification = (toastId: string, options: Record<string, unknown>) => {
    return this.toast.update(toastId, options);
  };

  closeNotification(toastId: string): void {
    this.toast.dismiss(toastId);
  }

  closeAll(): void {
    this.toast.clear();
  }

  private notificationClass(type?: TYPE): {
    toast: string;
    close: string;
  } {
    const defaultClass = "f360-toast-notification";

    const toastClass = {
      [TYPE.DEFAULT]: `${defaultClass}__toast--default`,
      [TYPE.INFO]: `${defaultClass}__toast--default`,
      [TYPE.SUCCESS]: `${defaultClass}__toast--success`,
      [TYPE.WARNING]: `${defaultClass}__toast--warning`,
      [TYPE.ERROR]: `${defaultClass}__toast--error`
    };

    if (type) {
      return {
        toast: `${defaultClass} ${toastClass[type]}`,
        close: `${defaultClass}__close`
      };
    }

    return {
      toast: `${defaultClass} ${toastClass[TYPE.DEFAULT]}`,
      close: `${defaultClass}__close`
    };
  }
}
